import Vue from 'vue'
import HOBPackAddToCart from './FlexPackAddToCart.vue'
import vueCustomElement from 'vue-custom-element'

Vue.use(vueCustomElement);

Vue.customElement('flex-pack-add-to-cart', HOBPackAddToCart, { shadow: false })
